export const SETTINGS = ['On Campus', 'Off Campus', 'Online'] as const;

export type Setting = typeof SETTINGS[number];

export const SETTINGS_API = ['In Person', 'Online'] as const;

export type SettingApi = typeof SETTINGS_API[number];
